import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Award } from 'lucide-react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Careers from './pages/Careers';
import Resources from './pages/Resources';
import { Modal } from './ui/overlay/Modal';
import { Button } from './ui/primitives/Button';
import './App.css';

const AWARD_MODAL_STORAGE_KEY = 'afb_award_modal_seen';

function App() {
  const [showAwardModal, setShowAwardModal] = useState(false);

  useEffect(() => {
    const seen = localStorage.getItem(AWARD_MODAL_STORAGE_KEY);
    if (!seen) {
      const t = setTimeout(() => setShowAwardModal(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const closeAwardModal = () => {
    setShowAwardModal(false);
    localStorage.setItem(AWARD_MODAL_STORAGE_KEY, 'true');
  };

  return (
    <Router>
      <div className="App min-h-screen bg-gradient-to-br from-gray-50 to-white">
        <Navbar />
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/resources" element={<Resources />} />
        </Routes>
        <Footer />

        <Modal
          open={showAwardModal}
          onClose={closeAwardModal}
          title="Industry Award"
          size="md"
          footer={
            <Button fullWidth onClick={closeAwardModal}>
              Continue
            </Button>
          }
        >
          <div className="text-center -mt-2">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br from-primary-600 to-accent-600 shadow-lg mb-4 mx-auto">
              <Award className="w-8 h-8 text-white" aria-hidden />
            </div>
            <p className="text-gray-600 leading-relaxed">
              Ecobank awarded African Financial Bridge the{' '}
              <span className="font-semibold text-primary-600">Best Agency Partnership</span> award.
            </p>
          </div>
        </Modal>
      </div>
    </Router>
  );
}

export default App;
